import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  shareBlock: '',
  isShareError: false,
  isShareSuccess: false,
  isShareLoading: false,
  shareErrorMsg: '',
};

export const creatingShareBlock = createAsyncThunk(
  'shareBlock/creatingShareBlock',

  async (headingkData, thunkAPI) => {
    try {
      const response = await blockService.creatingShareBlock(headingkData);
      return response;
    } catch (error) {
      const linkErrorMsg =
        (error.response && error.response.data && error.response.data.shareErrorMsg) ||
        error.shareErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(linkErrorMsg);
    }
  }
);

export const shareBlockSlice = createSlice({
  name: 'shareBlock',
  initialState,
  reducers: {
    resetQRCode: (state) => {
      state.isShareLoading = false;
      state.isShareSuccess = false;
      state.isShareError = false;
      state.shareErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingShareBlock.pending, (state) => {
        state.isShareLoading = true;
      })
      .addCase(creatingShareBlock.fulfilled, (state, action) => {
        state.isShareLoading = false;
        state.isShareSuccess = true;
        state.shareBlock = action.payload;
      })
      .addCase(creatingShareBlock.rejected, (state, action) => {
        state.isShareLoading = false;
        state.isShareError = true;
        state.shareErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetQRCode } = shareBlockSlice.actions;
export default shareBlockSlice.reducer;
